<template>
    <flat-button type="large" dark icon="chevron-up" class="bg-lunar fixed bottom-0 right-0 z-999999 mb-12 mr-4" @click="scrollToTop"></flat-button>
</template>

<script>
export default {
    methods: {
        scrollToTop() {
            window.scroll({top: 0, left: 0, behavior: 'smooth'});
        },
    }
}
</script>
